import styled from '@emotion/styled'
import { ITheme } from 'application/utils/type'

interface ITextProps {
  theme: ITheme 
  size?: number
  padded?: boolean
}

export const BText = styled('b')`
  label: BText;
  font-weight: 900;
`
export const SBText = styled(`h2`)<ITextProps>`
  label: SBText;
  font-weight: 700;
  font-size: ${(props) => (props.size ? props.size + 'px' : 'inherit')};
  padding: ${(props) => (props.padded ? '20px' : '')};
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
`
export const NText = styled('div')`
  label: NText;
  font-weight: 400;
`
export const PText = styled(SBText)`
  label: PText;
  color: ${(props) => props.theme.colors.primary};
`

export const PTextDiv = styled('div')<ITextProps>`
  label: PTextDiv;
  font-weight: 700;
  color: ${(props) => props.theme.colors.primary};
`
